import { Row, Typography, Button, Space, Image } from 'antd';
import { useHistory } from 'react-router-dom';
import alert from '../../assets/alert.png';
import { baseStyle } from '../../shared/styles/baseStyle';
import { modalButton, img, marginBottom, title } from './style';

const DeletionWarningModal = ({ setIsModalOpen }) => {
  const history = useHistory();

  return (
    <>
      <Row justify="center" style={marginBottom} align="middle">
        <Image style={img} src={alert} width={55} preview={false} />
        <Typography.Title level={4} style={title}>
          Μη αναστρέψιμη ενέργεια
        </Typography.Title>
      </Row>
      <Row>
        <Typography.Text>
          Είσαι βέβαιος/η ότι θέλεις να συνεχίσεις;
        </Typography.Text>
      </Row>
      <Row>
        <Typography.Text style={baseStyle.row}>
          Επιλέγοντας &quot;Ναι&quot;, δηλώνεις ότι καταλαβαίνεις και συμφωνείς
          με αυτές τις ενέργειες, συμπεριλαμβανομένης της διαγραφής του
          λογαριασμού σου και των δεδομένων της Εφαρμογής ShortDrive.
        </Typography.Text>
      </Row>
      <Row justify="space-evenly">
        <Space size={50}>
          <Button
            style={modalButton}
            onClick={() => {
              history.push('/deleteConfirmation');
            }}
          >
            Ναι
          </Button>
          <Button
            style={modalButton}
            onClick={() => {
              setIsModalOpen(false);
            }}
          >
            Όχι
          </Button>
        </Space>
      </Row>
    </>
  );
};
export default DeletionWarningModal;
